import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { Feature } from '../../types/Feature';
import { resetProfile } from '../profileSlice';

interface FeatureState {
  loading: boolean;
  items: Feature[];
}

const initialState: FeatureState = {
  loading: true,
  items: [],
};

const featureSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    setFeaturesLoading: state => {
      state.loading = true;
    },
    updateFeatures: (state, action: PayloadAction<Feature[]>) => {
      const active = (action.payload || []).filter(module => module.active);
      state.items = active;
      state.loading = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(resetProfile, () => initialState);
  },
});

export const { updateFeatures, setFeaturesLoading } = featureSlice.actions;
export default featureSlice.reducer;
